import React, { FC } from 'react';
import './AlarmsStatusIndicator.less';

interface Props {
  isCleared: boolean;
}

export const AlarmsStatusIndicator: FC<Props> = ({ isCleared }) => {
  return <div className={`${isCleared ? 'alarm-status-cleared' : 'alarm-status-active'}`} />;
};
